import { useQuery } from "@tanstack/react-query";
import {
  buildObservabilityData,
  isObservabilityContractMissing,
  backendHasObservabilityContract,
  type ObservabilityData,
  type Period,
  type BackendObservabilityResponse,
} from "@/services/observability";
import { OBSERVABILITY_QUERY, sinceForPeriod } from "@/services/observability";
import { graphqlRequest } from "@/services/deployment/client";

export function useObservabilityEvents(orgId: string | null, period: Period) {
  return useQuery<ObservabilityData>({
    queryKey: ["observability", orgId, period],
    queryFn: async () => {
      try {
        const hasContract = await backendHasObservabilityContract();
        if (!hasContract) {
          return { ...buildObservabilityData([], orgId!, period), contractUnavailable: true };
        }
        const response = await graphqlRequest<BackendObservabilityResponse>(OBSERVABILITY_QUERY, {
          organizationId: orgId,
          since: sinceForPeriod(period),
        });
        return buildObservabilityData(response.observabilityEvents ?? [], orgId!, period);
      } catch (error) {
        if (isObservabilityContractMissing(error)) {
          return { ...buildObservabilityData([], orgId!, period), contractUnavailable: true };
        }
        throw error;
      }
    },
    enabled: Boolean(orgId),
    staleTime: Infinity,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
